import { ValueOf } from "../../../constants";

export const VERIFICATION_DELIVERY_METHOD = {
    SMS: "SMS",
    EMAIL: "EMAIL",
    LOGIN: "LOGIN",
} as const;

export type VerificationDeliveryMethod = ValueOf<typeof VERIFICATION_DELIVERY_METHOD>;

export const VERIFICATION_STATE = {
    INITIAL: "INITIAL",
    WITH_SMS: "WITH_SMS",
    WITH_EMAIL: "WITH_EMAIL",
    CODE_SENT: "CODE_SENT",
    CODE_SENT_WITH_SMS: "CODE_SENT_WITH_SMS",
    CODE_SENT_WITH_EMAIL: "CODE_SENT_WITH_EMAIL",
} as const;

export type VerificationState = ValueOf<typeof VERIFICATION_STATE>;
